import type { Story } from "@/mocks/homeNews";

export function formatReads(n: string): string {
  return n;
}

const toneMap: Record<string, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-background-50",
  secondary: "bg-secondary-500 text-background-50",
};

export function Tag({ label, tone = "secondary" }: { label: string; tone?: string }) {
  const cls = toneMap[tone] || toneMap.secondary;
  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-semibold tracking-wide whitespace-nowrap ${cls}`}
    >
      {label}
    </span>
  );
}

export function MetaRow({ time, reads }: { time: string; reads?: string }) {
  return (
    <div className="flex items-center gap-3 text-xs text-foreground-600">
      <span className="inline-flex items-center gap-1 whitespace-nowrap">
        <i className="ri-time-line w-4 h-4 flex items-center justify-center" />
        {time}
      </span>
      {reads ? (
        <span className="inline-flex items-center gap-1 whitespace-nowrap">
          <i className="ri-fire-line w-4 h-4 flex items-center justify-center" />
          {reads}阅读
        </span>
      ) : null}
    </div>
  );
}

export function SectionHead({
  eyebrow,
  title,
  desc,
  id,
}: {
  eyebrow?: string;
  title: string;
  desc?: string;
  id?: string;
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6">
      <div>
        {eyebrow ? (
          <p className="inline-flex items-center gap-2 mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
            <span className="h-px w-6 bg-primary-500 inline-block" />
            {eyebrow}
          </p>
        ) : null}
        <h2
          id={id}
          className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-tight scroll-mt-24"
        >
          {title}
        </h2>
        {desc ? <p className="mt-2 text-sm text-foreground-600 max-w-xl">{desc}</p> : null}
      </div>
      <a
        href="#lead"
        className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
      >
        查看更多 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
      </a>
    </div>
  );
}

export type { Story };